{
  "RESET_PASSWORD": {
    "TITLE": "重設密碼",
    "DESCRIPTION": "請輸入您用來登入 Chatwoot 的電子郵件地址，以取得密碼重設說明。",
    "GO_BACK_TO_LOGIN": "如果您想返回登入頁面，",
    "EMAIL": {
      "LABEL": "電子郵件",
      "PLACEHOLDER": "請輸入您的電子郵件",
      "ERROR": "請輸入有效的電子郵件地址"
    },
    "API": {
      "SUCCESS_MESSAGE": "密碼重設連結已發送至您的電子郵件。",
      "ERROR_MESSAGE": "無法連線至 Woot 伺服器，請稍後再試。"
    },
    "SUBMIT": "送出"
  }
}
